import { defineCatalogue } from '../../../i18n';

export const mediaCatalogue = defineCatalogue(
  {
    unavailable: 'Mídia indisponível',
    'placeholder.pending': 'Mídia ainda não disponível',
    'gallery.prev': 'Item anterior',
    'gallery.next': 'Próximo item',
    'gallery.position': 'Item {n} de {total}',
    'gallery.count': '{count} itens',
    'coauthors.label': 'com {handles}',
  },
  {
    unavailable: 'Media unavailable',
    'placeholder.pending': 'Media not available yet',
    'gallery.prev': 'Previous item',
    'gallery.next': 'Next item',
    'gallery.position': 'Item {n} of {total}',
    'gallery.count': '{count} items',
    'coauthors.label': 'with {handles}',
  },
);

export const media = mediaCatalogue.t;
